import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { deleteProgramMember } from '../../services';
import { getProgramUsersInfiniteQueryKey } from '../keys';

export const useDeleteProgramMemberMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { programId: string; userId: string }>({
    async mutationFn({ programId, userId }) {
      await deleteProgramMember({
        body: {
          data: [{ entity_ids: [programId], entity_type: 'Program', roles: [], user_id: userId }],
        },
        routeParams: { programId, userId },
      });
    },
    async onSuccess(_, { programId }) {
      await queryClient.invalidateQueries({
        queryKey: getProgramUsersInfiniteQueryKey({ filter: { programId } }),
      });
    },
  });
};
